import React, { useState } from 'react';
import * as classes from './InterestCalculator.module.scss';
import Input from '../input/Input';
import {
  NON_NUMERIC,
  RATES,
  isValidDepositAmount,
  cleanDepositAmount,
  calculateInterest,
  calculateAmountWithInterest
} from './utilities';

const FixedTermInterestCalculator = ({ title, accountType = 'personal' }) => {
  const [depositAmount, _setDepositAmount] = useState(2000);
  const [inputError, setInputError] = useState(false);
  const row = RATES[accountType];

  const setDepositAmount = (inputValue) => {
    if (typeof inputValue === 'string') {
      // Show error if non numeric chars present
      if (inputValue.search(NON_NUMERIC) !== -1) {
        setInputError(true);
      }

      // Clean string, convert to Number and update depositAmount
      _setDepositAmount(cleanDepositAmount(inputValue, NON_NUMERIC));
    }
  };

  return (
    <div className={classes.interestCalculator}>
      <div className={classes.interestCalculator_wrapper}>
        <header className={inputError ? classes.interestCalculator_error : undefined}>
          <h2 className={classes.interestCalculator_title}>{title}</h2>
          <div className={classes.depositDetails}>
            <label className={classes.depositDetails_label} htmlFor="savingAmountInput">
              Deposit amount:
            </label>
            <div className={classes.depositDetails_amount}>
              <Input
                prefix={'£'}
                id="savingAmountInput"
                min={2000}
                max={1000000}
                step={100}
                type="number"
                value={String(depositAmount)}
                onChange={(event) => setDepositAmount(event.target.value)}
                onInput={() => setInputError(false)}
              />
            </div>
          </div>
          {inputError && <p className={classes.interestCalculator_error}>Please only enter numeric values</p>}

          {!isValidDepositAmount(depositAmount) && (
            <p className={classes.interestCalculator_error}>Please enter an amount between £2,000 and £1,000,000</p>
          )}
        </header>

        {isValidDepositAmount(depositAmount) && (
          <table className={classes.interestCalculator_table_data}>
            <thead>
              <tr>
                <th>Value after one year</th>
                <th>Interest earned</th>
                <th>Interest rate (AER)</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.label}>
                <td>{calculateAmountWithInterest(depositAmount, row.rate)} </td>
                <td>{calculateInterest(depositAmount, row.rate)} </td>
                <td>{row.label}</td>
              </tr>
            </tbody>
          </table>
        )}
        <p className={classes.interestCalculator_additional_info}>
          Fixed Gross/Annual Equivalent Rate (AER): {row.label}
          <br></br> These calculations are for illustrative purposes only. Terms and conditions apply.
        </p>
      </div>
    </div>
  );
};

export default FixedTermInterestCalculator;
